import { useState } from 'react'
import { useUI } from '@/store/ui'
import { Button, Card, Input } from '@diwata/ironvale'

export function Settings() {
  const { daemonUrl, conclaveUrl, assayUrl, assayApiKey, loreUrl, gatewayUrl, updateSettings } = useUI()

  const [form, setForm] = useState({ daemonUrl, conclaveUrl, assayUrl, assayApiKey, loreUrl, gatewayUrl })
  const [saved, setSaved] = useState(false)

  function save() {
    updateSettings(form)
    setSaved(true)
    setTimeout(() => setSaved(false), 2000)
  }

  const field = (key: keyof typeof form, label: string) => (
    <div className="ap-field">
      <label className="ap-label">{label}</label>
      <Input
        value={form[key]}
        onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
      />
    </div>
  )

  return (
    <div style={{ maxWidth: 480 }}>
      <div className="ap-page-header">
        <div className="ap-page-title">Settings</div>
      </div>

      <Card>
        <div className="ap-form">
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--ae-color-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            Service URLs
          </div>
          {field('daemonUrl',   'DAEMON')}
          {field('conclaveUrl', 'Conclave')}
          {field('assayUrl',    'Assay URL')}
          {field('assayApiKey', 'Assay API Key')}
          {field('loreUrl',     'Lore')}
          {field('gatewayUrl',  'Gateway')}
          <Button style={{ alignSelf: 'flex-start' }} onClick={save}>
            {saved ? 'Saved' : 'Save'}
          </Button>
        </div>
      </Card>
    </div>
  )
}
